
export class TracedoSyncFactory {
    public static makeTracedoSync() {
       return {
           customerPartnerId: false,
           customerPartnerPicUserId: false,
           supplierPartnerPicUserId: false,
           myPicUserId: false,
           mySeasonId: false,
           kindId: false,
           roadTypeId: false,
           serviceTypeId: false,
           clientRef: false,
           clientRef2: false,
           clientRef3: false,
           myUzp: false,
           incotermsId: false,
           sealNr: true,
           cntrNr: true,
           bdpCntrTypeId: false,
           rejdar: false,
           vessel: false,
           voyageNr: false,
           trainNr: false,
           mbl: false,
           hbl: false,
           customOffice: false,
           shipperName: false,
           consigneeName: false,
           depotId: true,
           pickupAddressId: false,
           pickupContactId: false,
           loadingReference: false,
           atd: false,
           etdFrom: false,
           etdTo: false,

           deliveryAddressId: false,
           deliveryContactId: false,
           unloadingReference: false,
           ata: false,
           etaFrom: false,
           etaTo: false,

           carriersOriginData: false,
           carriersDestinationData: false,

           railLoadAddress: false,
           railUnloadAddress: false,
           railLoadContact: false,
           railUnloadContact: false,

           railLoadeta: false,
           railLoadetd: false,
           railLoadata: false,
           railLoadatd: false,

           railUnloadeta: false,
           railUnloadetd: false,
           railUnloadata: false,
           railUnloadatd: false,
       }
    }

}